export default __webpack_public_path__ + "static/media/Messenger.9b56418b.svg";